<!-- 平台资源建设 -->
<template>
    <div class="resource-construction">
        <div class="resource-construction-top">
            <div class="title">平台资源建设</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="resource-construction-list">
            <div class="resource-construction-item" v-for="item in resList" :key="item.id">
                <div class="resource-name">{{ item.name }}</div>
                <!-- <div class="resource-number">{{ item.number }}</div> -->
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="`code_${item.name}`"
                    :end-val="item.number"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="item.number > 100000 ? 1 : -1"
                    style="height:100%;"
                >
                </count-up>
            </div>
        </div>
        <div class="resource-construction-echarts">
            <div class="left-echarts">
                <div class="title-tips">
                    <div class="tips"></div>
                    <div class="title">资源分布</div>
                </div>
                <div style="width:100%;height:100%;" :id="'leftChartsId'" v-show="!isShowLeft"></div>
                <div class="chart-error" v-show="isShowLeft">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
            <div class="right-echarts">
                <div class="title-tips">
                    <div class="tips"></div>
                    <div class="title">资源类型</div>
                </div>
                <div style="width:100%;height:100%;" :id="'rightChartsId'" v-show="!isShowRight"></div>
                <div class="chart-error" v-show="isShowRight">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
import { getPlatformResourceTotalAPI, getPlatformResourceDistributionAPI, getPlatformResourceTypeAPI } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
export default {
    name: 'resource-construction',
    components: {
        CountUp
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            resList:[],
            //左侧echarts是否有数据
            isShowLeft:false,
            //右侧echarts是否有数据
            isShowRight:false,
            //资源分布数组
            resDistributionList:[],
            //资源类型数组
            resTypeList:[],
            //资源总数
            resTotal:0
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.init();
            }
        }
    },
    methods: {
        initEcharts(dom,dataList,type){
            let myChart = echarts.init(dom)
            let option;
            option = {
                tooltip: {
                    trigger: 'item',
                    // show: false,
                    // 数据的显示方式
                    formatter: (param) => {
                        return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                    }
                },
                legend: {
                    selectedMode: false, // 是否允许点击
                    type: 'scroll',
                    orient: 'vertical',
                    right:type == 'type' ? 10 : 20,
                    top: 30,
                    bottom: 0,
                    padding: 3, //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
                    itemGap: 10, //图例每项之间的间隔
                    itemWidth: 9, //图例标记的图形宽度
                    itemHeight: 9,
                    formatter: (name) => {
                        const data = dataList.find((item)=>{
                            return item.name == name;
                        })
                        if(type == 'type'){
                            return `{name|${name}}`;
                        }else{
                            return `{name|${name}}{percent|${data.number || 0}%}{count|${data.value || 0}}`;
                        }
                    },
                    textStyle: {
                        rich: {
                            name: {
                                fontSize: 14,
                                verticalAlign: 'right',
                                align: 'left',
                                width: 90,
                                color:"#7ABFDB"
                            },
                            percent: {
                                fontSize: 14,
                                align: 'left',
                                width: 60,
                                color:"#7ABFDB"
                            },
                            count: {
                                fontSize: 14,
                                align: 'left',
                                color:"#7ABFDB"
                            }
                        },
                        color: '#909399',
                        borderWidth: 2
                    },
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: type == "type" ? ['40%','55%'] : ['20%', '55%'],
                        avoidLabelOverlap: false,
                        color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                        label: {
                            show: false,
                            position: 'center',
                            formatter: (data) => {
                                return (
                                "{a|" +
                                data.data.number +
                                "%}" +
                                "\r\n" +
                                "{b|" +
                                data.data.name +
                                "}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 16,
                                    lineHeight: 20,
                                    color: "#fff",
                                    align: "center",
                                    fontWeight: "bold",
                                },
                                b: {
                                    fontSize: 12,
                                    lineHeight: 16,
                                    fontWeight: "bold",
                                    color: "#7ABFDB",
                                    align: "center",
                                },
                            },
                            backgroundColor: "transparent",
                            fontWeight: "bold",
                            fontSize: "15",
                            padding: 6,
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: dataList
                    }
                ]
            };
            option && myChart.setOption(option)
        },
        /**
         * @name 初始化数据
         */
        async init(){
           //获取资源分布统计
           await this.getPlatformResourceDistribution();
           //获取资源类型统计
           await this.getPlatformResourceType();
        },
        /**
         * @name 获取资源类型统计
         */
        getPlatformResourceType(){
            this.resTypeList = []
            getPlatformResourceTypeAPI({...this.params}).then((res)=>{
                let resTypeList = []
                let maxNum = 0;
                for (let key in res) {
                    if (res.hasOwnProperty(key)) {
                        maxNum += res[key];
                    }
                }
                resTypeList.push({
                    value:res.otherNum || 0,
                    name:'其他',
                    number:Number((res.otherNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.wordNum || 0,
                    name:'Word',
                    number:Number((res.wordNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.imageNum || 0,
                    name:'图片',
                    number:Number((res.imageNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.pdfNum || 0,
                    name:'PDF',
                    number:Number((res.pdfNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.videoNum || 0,
                    name:'视频',
                    number:Number((res.videoNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.pptNum || 0,
                    name:'PPT',
                    number:Number((res.pptNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.push({
                    value:res.musicNum || 0,
                    name:'音频',
                    number:Number((res.musicNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resTypeList.sort((a, b) => b.value - a.value);
                this.resTypeList = resTypeList;
                this.initEcharts(document.getElementById('rightChartsId'),this.resTypeList,'type')
            }).catch((err)=>{
                this.$Message.error('资源类型统计获取失败！');
            })
        },
        /**
         * @name 获取资源分布统计
         */
        getPlatformResourceDistribution(){
            this.resTotal = 0;
            this.resDistributionList = []
            getPlatformResourceDistributionAPI({...this.params}).then((res)=>{
                let resDistributionList = []
                let maxNum = 0;
                for (let key in res) {
                    if (res.hasOwnProperty(key)) {
                        maxNum += res[key];
                    }
                }
                resDistributionList.push({
                    value:res.qyNum || 0,
                    name:'区域资源中心',
                    number:Number((res.qyNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.xbNum || 0,
                    name:'校本资源中心',
                    number:Number((res.xbNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.jswpNum || 0,
                    name:'教师网盘',
                    number:Number((res.jswpNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.zhpsNum || 0,
                    name:'综合评审',
                    number:Number((res.zhpsNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.zxkcNum || 0,
                    name:'在线课程',
                    number:Number((res.zxkcNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.msgzsNum || 0,
                    name:'名师工作室',
                    number:Number((res.msgzsNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.tpkNum || 0,
                    name:'听评课',
                    number:Number((res.tpkNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.jtbkNum || 0,
                    name:'集体备课',
                    number:Number((res.jtbkNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.push({
                    value:res.tshdNum || 0,
                    name:'特色活动',
                    number:Number((res.tshdNum || 0)/maxNum * 100).toFixed(2) || 0
                })
                resDistributionList.forEach((item)=>{
                    this.resTotal = this.resTotal + item.value
                })
                //获取资源建设总量
                this.getPlatformResourceTotal();
                resDistributionList.sort((a, b) => b.value - a.value);
                this.resDistributionList = resDistributionList;
                this.initEcharts(document.getElementById('leftChartsId'),this.resDistributionList,'res')
            }).catch((err)=>{
                this.$Message.error('资源分布统计获取失败！');
            })
        },
        /**
         * @name 获取资源建设总量
         */
        getPlatformResourceTotal(){
            this.resList = []
            getPlatformResourceTotalAPI({...this.params}).then((res)=>{
                let resList = []
                resList.push({
                    name:"资源建设量",
                    id:'1',
                    number:this.resTotal
                })
                resList.push({
                    name:"资源预览量",
                    id:'1',
                    number:res.resView
                })
                resList.push({
                    name:"资源引用量",
                    id:'1',
                    number:res.resCite
                })
                this.$emit("interact-number",res.interactNum,this.resTotal)
                this.resList = resList;
            }).catch((err)=>{
                this.$Message.error('资源建设总量获取失败！');
            })
        },
    },
    mounted(){
        //初始化数据
        this.init();
    },
}
</script>
  
<style lang="scss" scoped>
.resource-construction{
    width: 100%;
    height: 280px;
    background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 15px;
    .resource-construction-top{
        text-align: center;
        position: relative;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .resource-construction-list{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 15px;
        .resource-construction-item{
            display: inline-flex;
            align-items: center;
            .resource-name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                display: inline-block;
                margin-right: 10px;
            }
            .resource-number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                margin-left: 10px;
                display: inline-block;
            }
        }
    }
    .resource-construction-echarts{
        display: flex;
        align-items: center;
        height: calc(100% - 80px);
        width: 100%;
        .left-echarts,
        .right-echarts{
            width: 50%;
            height: 100%;
            position: relative;
            .title-tips{
                position: absolute;
                top: 0;
                left: 10px;
                display: flex;
                align-items: center;
                .tips{
                    width: 14px;
                    height: 14px;
                    display: inline-block;
                    background: linear-gradient(90deg, #09132A, #24C4DC);
                    margin-right: 5px;
                }
                .title{
                    font-size: 18px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #27CDE6;
                    display: inline-block;
                }
            }
        }
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
</style>